<template>
  <v-container fluid scroll-region transition="scroll-x-transition">
    <v-row align="center">
      <v-col cols="6" justify-center>
        Erfolgreich gespeichert. Sie können den Browser nun schließen.
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import QuestionnaireLayout from '@/Layouts/Questionnaire'

export default {
   metaInfo () {
      // don't know your return object structure,
      // maybe you should check whole this.getViewPage
      return {
         title: this.title ? this.title : 'Loading...',
      }
   },
   layout: (h, page) => h(QuestionnaireLayout, [page]),
}
</script>

<style scoped>
</style>
